<template>
  <div v-if="images.length > 0" class="thumbnail">
    <div
      class="thumbnail-full"
    >
      <img :src="selectedThumbnail" />
      <button
        @click.prevent="showImage(selectedThumbnail)"
        class="enlarge-button"
      >
        View
      </button>
    </div>

    <div v-if="images.length > 1" class="thumbnail-list">
      <a
        v-for="(thumbnail, i) in images"
        :key="i"
        class="thumbnail-list-item"
        :class="{ selected: i === selectedIndex }"
        @click.prevent="selectThumbnail(i)"
      >
        <img :src="thumbnail" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      default: () => ([])
    }
  },

  data () {
    return {
      selectedIndex: 0
    }
  },

  computed: {
    selectedThumbnail () {
      return this.images[this.selectedIndex]
    }
  },

  methods: {
    selectThumbnail (index) {
      this.selectedIndex = index
    },

    showImage (image) {
      this.$modal.show({
        text: `<img class="img-enlarged" src="${image}" />`,
        okButtonText: 'ปิด'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.thumbnail-full {
  position: relative;

  img {
    margin: 0 auto;
    display: block;
  }
}

.thumbnail-list {
  display: flex;
  justify-content: space-around;

  .thumbnail-list-item {
    display: block;
    border: 2px solid transparent;

    &.selected {
      border-color: red;
    }
  }
}

.enlarge-button {
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// Thumbnail.vue?0caf5f58